var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.show)?_c('section',{on:{"click":_vm.goToHome}},[_c('MenuItem',{attrs:{"item":_vm.menuConfig}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }